function Footer() {
    return (
      <footer className="appFooter wrapper">
        <p>
          Made by
          <a href="https://www.paulavivas.ca/"> Paula Vivas Teixeira</a> at <a href="https://junocollege.com/">Juno College of Technology</a>
        </p>
        <p>This page was created using React and <a href="https://www.ticketmaster.ca/"> Ticketmaster API</a>. Visit my <a href="https://github.com/paulavivasteixeira">Github page</a> to view the code.</p>
      </footer>
    );
  }
  
  export default Footer;
